import i18next from 'i18next';
import * as yup from 'yup';
import envConfig from './env';

const configureYup = () => {
  const applyLocale = () => configureLang(i18next.language);

  if (i18next.isInitialized) {
    applyLocale();
  }
  else {
    i18next.on('initialized', applyLocale);
  }

  i18next.on('languageChanged', (lang) => configureLang(lang));
};

function configureLang(lang?: string) {
  const normalized = (lang ?? envConfig.locale.default ?? 'fa').split('-')[0]?.toLowerCase();
  if (normalized === 'en') {
    return configureEN();
  }
  return configureFA();
}

function configureEN() {
  return yup.setLocale(yup.defaultLocale);
}

function configureFA() {
  yup.setLocale({
    mixed: {
      default: '${path} نامعتبر است.',
      required: '${path} یک فیلد اجباری است.',
      oneOf: '${path} باید یکی از مقادیر رو به رو باشد: ${values}',
      notOneOf: '${path} نباید یکی از مقادیر رو به رو باشد: ${values}',
    },
    string: {
      length: '${path} باید ${length} کاراکتر باشد.',
      min: '${path} باید حداقل ${min} کاراکتر باشد.',
      max: '${path} باید حداکثر ${max} کاراکتر باشد.',
      matches: '${path} باید با الگوی رو به رو مچ باشد: "${regex}"',
      email: 'ایمیل وارد شده نامعتبر است.',
      trim: 'ابتدا و انتهای ${path} نباید کاراکتر فاصله باشد.'
    },
    number: {
      min: '${path} باید بزرگتر یا مساوی ${min} باشد.',
      max: '${path} باید کوچکتر یا مساوی ${max} باشد.',
      lessThan: '${path} باید کمتر از ${less} باشد.',
      moreThan: '${path} باید بیشتر از ${more} باشد.',
      positive: '${path} باید مثبت باشد.',
      negative: '${path} باید منفی باشد.',
      integer: '${path} باید یک عدد صحیح باشد.',
    }
  });
}

export default configureYup;
